import React from "react";
import { routes } from "../../../constants/routes";
import { OnHoverTooltip } from "../../common/OnHoverTooltip";
import { user } from "../../../user";
import { roles } from "../../../constants";

interface Props {
    referenceName: string;
    legalName: string;
    code?: string;
    overlayText?: string;
    onClick?: () => void;
    disabledTooltip?: boolean;
}

export function BankLink({ referenceName, legalName, code, overlayText, onClick, disabledTooltip }: Props) {
    const displayName = code ? code.toUpperCase() : legalName;
    const isLinkAvailable = user.hasRoles(...roles.banksAccess());

    const handleClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.preventDefault();

        if (onClick) {
            onClick();
        }

        window.open(
            window.location.origin + routes.manageBanksUrl(referenceName)
        );
    };

    return (
        <OnHoverTooltip
            overlay={overlayText || legalName}
            disabled={disabledTooltip}
        >
            {isLinkAvailable ? (
                <span
                    className="link-filter text-ellipsis"
                    onClick={handleClick}
                >
                    {displayName}
                </span>
            ) : (
                <span>{displayName}</span>
            )}
        </OnHoverTooltip>
    );
}
